module.exports = __webpack_public_path__ + "media/images/menu/neptune-ba7d8a2c40f209ac90b201ce909bdca3.jpg";